import { t } from "i18next";

import "styles/quill-content.scss";

import styles from "./FAQPreview.module.scss";

interface FAQPreviewProps {
  question: string;
  // HTML (Quill) body
  answer: string;
}

// Live "how it looks in the app" preview: a CSS phone frame with the FAQ
// detail screen layout of the reseller app. The article body is rendered as
// raw HTML inside a `.ql-content` wrapper styled by `styles/quill-content.scss`
// to approximate the app's RenderHtml output.
const FAQPreview = ({ question, answer }: FAQPreviewProps) => {
  return (
    <div className={styles.preview}>
      <div className={styles.preview_phone}>
        <div className={styles.preview_statusBar} />
        <div className={styles.preview_header}>
          <span className={styles.preview_backArrow}>‹</span>
          <span className={styles.preview_headerTitle}>{t("FAQ")}</span>
        </div>
        <div className={styles.preview_screen}>
          <h2 className={styles.preview_question}>{question}</h2>
          <div
            className="ql-content"
            dangerouslySetInnerHTML={{ __html: answer }}
          />
        </div>
      </div>
      <p className={styles.preview_hint}>{t("App preview (approximate)")}</p>
    </div>
  );
};

export default FAQPreview;
